import { Dispatch } from "redux";
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import jwtAxios from "../../@crema/services/auth/jwt-auth";
import { AppActions } from "types";
import { AxiosResponse } from "axios";
import {
  CREATE_Customer,
  GET_Customer,
  SET_Customer_DATA,
  UPDATE_Customer,
  SET_CITY_DATA,
  SET_AREAS_BY_CITY,
  DELETE_Customer,
} from "types/actions/customerMaster.action";
import { toastService } from "@crema/core/toast/toastService";
export const getCustomer = (search: string, page: number, limit: number) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const response = await jwtAxios.get("customer-care", {
        params: { searchTerm: search, page, limit },
      });

      if (response.status === 200 && response.data.status === "success") {
        dispatch(fetchSuccess());

        const mappedCustomers = response.data.data.map((item: any) => ({
          ...item,
          PageID: item.id,
        }));

        dispatch({
          type: GET_Customer,
          payload: {
            customer: mappedCustomers,
            count: mappedCustomers.length,
          },
        });
      } else {
        dispatch(fetchError("Something went wrong, Please try again!"));
      }
    } catch (error: any) {
      dispatch(fetchError(error.message));
    }
  };
};
export const getCustomerDetail = (customerId: string | number) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const response = await jwtAxios.get(`/customer-care/${customerId}`);
      if (response.status === 200) {
        dispatch(fetchSuccess());
        toastService.success("Lead Save successfully!");
        dispatch({ type: SET_Customer_DATA, payload: response.data.data });
      } else {
        toastService.error("Something went wrong, Please try again!");
        dispatch(fetchError("Something went wrong, Please try again!"));
      }
    } catch (error: any) {
      toastService.error(error?.message || "Something went wrong!");
      dispatch(fetchError(error.message));
    }
  };
};
export const sendLeadSms = (customerId: string | number) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const response = await jwtAxios.get(`/customer-care/sendSms/${customerId}`);
      if (response.status === 200) {
        dispatch(fetchSuccess());
        toastService.success("Message Send Successfully !");
        dispatch({ type: SET_Customer_DATA, payload: response.data.data });
      } else {
        dispatch(fetchError("Something went wrong, Please try again!"));
      }
    } catch (error: any) {
      dispatch(fetchError(error.message));
    }
  };
};
export const fetchCities = (stateId:any) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const response = await jwtAxios.get(`/cities/getCitiesByState/${stateId}`, );
      dispatch(fetchSuccess());
      dispatch({
        type: SET_CITY_DATA,
        payload: response.data.data,
      });
      return response;
    } catch (error: any) {
      dispatch(fetchError(error.message));
      throw error;
    }
  };
};
export const fetchAreasByCityId = (cityId: number) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const response = await jwtAxios.get(`/area/getAreaByCity/${cityId}`);
      if (response.status === 200 && response.data.success === true) {
        dispatch(fetchSuccess());
        dispatch({ type: SET_AREAS_BY_CITY, payload: response.data });
        return response.data.data;
      } else {
        dispatch(fetchError("Something went wrong, please try again!"));
        throw new Error("Fetch areas failed");
      }
    } catch (error: any) {
      console.error("Error fetching areas:", error);
      dispatch(fetchError(error.message));
      throw error;
    }
  };
};
export const fetchStates = () => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const response = await jwtAxios.get(`/states`);
      if (response.status === 200) {
        dispatch(fetchSuccess());
        dispatch({
          type: 'SET_STATES_DATA',
          payload: response.data.data,
        });
      } else {
        dispatch(fetchError("Failed to fetch states"));
      }
      return response;
    } catch (error: any) {
      dispatch(fetchError(error.message));
      throw error;
    }
  };
};
export const createCustomer = (payload: any, neodoveData?: any) => {
  return async (dispatch: Dispatch): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());

    try {
     const leadApiUrl = process.env.REACT_APP_LEAD_API
        console.log("Payload for creating customer:", neodoveData);
      console.log("Neodove Data:", leadApiUrl);

      if (neodoveData && leadApiUrl) {
        await fetch(leadApiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(neodoveData),
        });
      }


      const response = await jwtAxios.post('/customer-care', payload);

      if (response.status === 200) {
        dispatch(fetchSuccess());
         toastService.success("Lead Save successfully!");
        dispatch({ type: CREATE_Customer, payload: response.data });
      } else {
         toastService.error("Lead Unable successfully!");
        dispatch(fetchError('Failed to create customer'));
      }

      return response;
    } catch (error: any) {
      dispatch(fetchError(error.message || 'Something went wrong'));
      return Promise.reject(error);
    }
  };
};
export const deleteCustomer = (customerId: number | string) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());

    try {
      const response = await jwtAxios.delete(`/customer-care/${customerId}`);
      if (response.status === 200) {
        dispatch(fetchSuccess());
        dispatch({ type: DELETE_Customer, payload: response.data });
        return response.data;
      } else {
        throw new Error("Failed to delete customer");
      }
    } catch (error: any) {
      dispatch(fetchError(error.message || "Unexpected error"));
      throw error;
    }
  };
};

export const updateCustomer = (customerId: string | number, payload: any) => {
  return async (dispatch: Dispatch<AppActions>): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());

    try {
      const response = await jwtAxios.put(`/customer-care/${customerId}`, payload);
      if (response.status === 200) {
        dispatch(fetchSuccess());
        dispatch({ type: UPDATE_Customer, payload: response.data });
      } else {
        dispatch(fetchError("Failed to update customer"));
      }
      return response;
    } catch (error: any) {
      dispatch(fetchError(error.message));
      return Promise.reject(error);
    }
  };
};
